import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGa4, trackPageView } from "@/lib/analytics";

/** SPA page_view + one-time gtag bootstrap. Mount inside BrowserRouter. */
export default function Ga4Tracker() {
  const location = useLocation();

  useEffect(() => {
    initGa4();
  }, []);

  useEffect(() => {
    initGa4();
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
